import { useLocation } from 'react-router-dom';
import api from '../../../data/api';
import { ProducePopups } from './components/ProducePopup';
import { useFetchPopupById } from '../../../data/swrs/popup';
import { formatDate } from './util/formatDate';

const EditPopups = () => {
	const location = useLocation();
	const popupId = location.pathname.split('/')[3];

	const { data: PopupDetails, error } = useFetchPopupById(popupId);

	if (error) {
		return <div>{'Something Went Wrong'}</div>;
	}

	if (!PopupDetails) {
		return <div>Loading...</div>;
	}

	const popupData = PopupDetails.data;
	const TIMEZONE = 'America/New_York';

	const initialValues = {
		headerText: popupData.headerText || '',
		image: popupData.thumbnailLink || null,
		description: popupData.description || '',
		isActive: popupData.isActive || false,
		startDate: popupData.startDate ? new Date(popupData.startDate) : new Date(),
		endDate: popupData.endDate ? formatDate(popupData.endDate) : new Date(),
		primaryCTA: {
			text: popupData.primaryCTA?.text || '',
			redirectUrl: popupData.primaryCTA?.redirectUrl || ''
		},
		secondaryCTA: {
			text: popupData.secondaryCTA?.text || '',
			redirectUrl: popupData.secondaryCTA?.redirectUrl || ''
		},
		viewCount: popupData.viewCount,
		startDateLocal: popupData.startDateLocal,
		endDateLocal: popupData.endDateLocal,
		deviceVisibility: Array.isArray(popupData.deviceVisibility)
			? popupData.deviceVisibility.map(d => String(d).toLowerCase())
			: []
	};

	const handleSubmit = async popupObject => {
		return await api.editPopupApi(popupId, { ...popupObject });
	};

	return <ProducePopups initialValues={initialValues} onSubmit={handleSubmit} />;
};

export default EditPopups;
